import type { ReactNode } from "react";
import "./MonthPane.scss";
import { DateStyle } from "@/shared/utils/Dates.ts";
import {
  type DateRange,
  DayPicker,
  type DayPickerLocale,
  rangeIncludesDate,
} from "react-day-picker";
import useDateFormatter from "@/shared/custom-hook/useDateFormatter.ts";
import { capitalize } from "@/shared/utils/Strings.ts";
import PreviousNextButton from "@/shared/components/generic/button/PreviousNextButton.tsx";
import "@/shared/components/generic/date-range/DateRangePicker.scss";

interface Properties {
  locale: DayPickerLocale;
  selectedRange: DateRange;
  timeZone: string;
  onPickDay: (date: Date) => void;
  startEnd: "start" | "end";
  displayMonthDate: Date;
  onClickMove: () => void;
}

export default function MonthPane(props: Properties): ReactNode {
  const { formatDate } = useDateFormatter(props.timeZone);
  const date =
    props.startEnd === "start" ?
      props.selectedRange.from
    : props.selectedRange.to;
  if (date === undefined) return undefined;
  return (
    <div className={`month-pane ${props.startEnd}`}>
      <div className="header">
        {props.startEnd === "start" && (
          <PreviousNextButton
            direction="previous"
            onClick={props.onClickMove}
          />
        )}
        <div className="center-label">
          {capitalize(
            formatDate(props.displayMonthDate, DateStyle.YEAR_MONTH_WORD),
          )}
        </div>
        {props.startEnd === "end" && (
          <PreviousNextButton direction="next" onClick={props.onClickMove} />
        )}
      </div>
      <div className="date-range-picker">
        <DayPicker
          key={props.displayMonthDate.toISOString()}
          defaultMonth={props.displayMonthDate}
          modifiers={{
            range_start: props.selectedRange.from,
            range_end: props.selectedRange.to,
            range_middle: (d: Date) =>
              rangeIncludesDate(props.selectedRange, d, true),
          }}
          locale={props.locale}
          showOutsideDays={true}
          disableNavigation={true}
          hideNavigation={true}
          onDayClick={props.onPickDay}
        />
      </div>
    </div>
  );
}
